<template>
  <div class="bg bg21">
    <div class="class--con">
      <class-but  @forward="forward" />
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";

export default {
  name: "cutePets",
  components: {ClassBut},
  data() {
    return {}
  },
  methods: {
    forward() {
      //学期亮点展示
      this.$router.push({
        name: 'PageNinth',
        query: this.$route.query,
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import "../ConferenceItem/reportClass.less";
</style>
